import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import configStore from "./store";
import ProfitabilityDemo from "./pages/Profitability/ProfitabilityDemo";

const store = configStore();
const root = ReactDOM.createRoot(document.getElementById("root"));

// ────────────────────────────────────────────────────────────────────────────
// Standalone Demo mode — בקטע `/demo-only/*` מציג רק את ה-Profitability
// Component Library Demo (ללא Sidebar/Login/Redux היקפי).
// שאר ה-URLs (root, /dashboard, /profitability/*, ...) רצים ב-App רגיל.
// ────────────────────────────────────────────────────────────────────────────
if (window.location.pathname.startsWith("/demo-only")) {
  root.render(
    <BrowserRouter basename="/demo-only">
      <ProfitabilityDemo />
    </BrowserRouter>
  );
} else {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
